import {
  $primaryColorsGreen,
  Box,
  Flex,
  styled
} from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled(Flex)`
  box-sizing: border-box;
  width: max-content;
  align-items: center;
  justify-content: center;
`;

export const Container = styled(Box)`
  width: ${(props) => `${props.size}px` || "20px"};
  height: ${(props) => `${props.size}px` || "20px"};
  border: 1.5px solid
    ${(props) => (props.isSelected ? $primaryColorsGreen.normal : `#e0e0e8`)};
  cursor: pointer;
  position: relative;
  background: white;
  border-radius: 50%;
  box-sizing: border-box;

  ${(props) =>
    props.isSelected &&
    `
    :after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      background: ${$primaryColorsGreen.normal};
      height: 65%;
      width: 65%;
      border-radius: 50%;
      box-sizing: border-box;
      transform: translateX(-50%) translateY(-50%);
    }
    `}
`;
